import { useParams } from "react-router";
import { ContentCourse } from "../../../../domains/ContentCourse";
import { ContentCourseStudent } from "../../../../domains/Student";
import { useContentCourseDetailQuery } from "../../../../hooks/http/useContentCoursesApi";
import { useQueryError } from "../../../../hooks/http/useQueryError";
import { useModalManager } from "../SelectDistributeTagModal";
import { useDeleteContentCourseTag } from "./useDeleteContentCourseTag";
import { useFetchContentCourseStudents } from "./useFetchContentCourseStudents";

type UseSectionsSettingsCourseStudentsHook = {
  course: ContentCourse | undefined;
  courseStudents: ContentCourseStudent[];
  isCourseLoading: boolean;
  isCourseStudentsLoading: boolean;
  isDeleting: boolean;
  onClickDelete: () => void;
  sectionId: string;
  onFetchNextPage: () => void;
} & ReturnType<typeof useModalManager>;

export const useSectionsSettingsCourseStudents =
  (): UseSectionsSettingsCourseStudentsHook => {
    const { sectionId = "", contentCourseId: courseId = "" } = useParams<{
      sectionId: string;
      contentCourseId: string;
    }>();
    const modalManagerState = useModalManager();
    // コース詳細の取得
    const courseResult = useContentCourseDetailQuery({
      sectionId,
      courseId,
    });
    useQueryError(courseResult.error);
    // コース配信生徒一覧の取得
    const courseStudentsResult = useFetchContentCourseStudents({
      sectionId,
      courseId,
    });

    // コース配信生徒一覧のパース
    const courseStudents = courseStudentsResult.data
      ? courseStudentsResult.data?.pages.reduce<ContentCourseStudent[]>(
          (prev, current) => [...prev, ...current.data],
          [],
        )
      : [];
    // コース配信対象タグ削除処理
    const { onDelete: onClickDelete, isDeleting } = useDeleteContentCourseTag(
      sectionId,
      courseId,
    );

    return {
      course: courseResult.course,
      courseStudents,
      isCourseLoading: courseResult.isLoading,
      isCourseStudentsLoading:
        courseStudentsResult.isLoading ||
        courseStudentsResult.isFetchingNextPage,
      onFetchNextPage: courseStudentsResult.fetchNextPage,
      isDeleting,
      onClickDelete,
      ...modalManagerState,
      sectionId,
    };
  };
